import IRequestsFilter from "interfaces/IRequestFilter";
import { GlobalState } from "little-state-machine";

export const updateRequestsFilter = (state: GlobalState, requestsFilter: IRequestsFilter) => ({
  ...state,
  requestsFilter
});
